import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const mount = (el, i) => {
  ReactDOM.render(<App index={i} />, el);
};

/**
 * Finds the index of all the elements in the array that match the specified regex pattern.
 * @param {*} regex
 * @returns {Array} An array of indexes of the elements that match the specified regex pattern.
 */
Array.prototype.matchRegex = function (regex) {
  const pattern = new RegExp(regex);
  return this.reduce(function (acc, curr, index, arr) {
    if (pattern.test(curr)) {
      acc.push(index);
    }
    return acc;
  }, []);
};

/**
 * Counts the number of configurations specified in the window.homewise.productTable array of objects.
 */
const calculateClasses = () => {
  const classes = [],
    config = window?.homewise?.productTable;

  if (config !== undefined && Array.isArray(config)) {
    config.forEach((config, index) => {
      classes.push(`.homewise_product_table_${index}`);
    });
  } else classes.push('.homewise_product_table');

  return classes;
};

if (process.env.NODE_ENV === 'development') {
  const classes = calculateClasses(),
    devRoots = document.querySelectorAll(classes.join(','));

  if (devRoots.length > 0) {
    devRoots.forEach((el) => {
      const classIndex = el?.className?.split(' ')?.matchRegex(/^homewise_product_table_\d+$/),
        absoluteIndex = el?.className?.split(' ')[classIndex]?.split('_')[3];
      mount(el, absoluteIndex);
    });
  }
} else if (process.env.NODE_ENV === 'production') {
  const classes = calculateClasses(),
    prodRoots = document.querySelectorAll(classes.join(','));

  if (prodRoots.length > 0) {
    prodRoots.forEach((el) => {
      const classIndex = el?.className?.split(' ')?.matchRegex(/^homewise_product_table_\d+$/),
        absoluteIndex = el?.className?.split(' ')[classIndex]?.split('_')[3];
      mount(el, absoluteIndex);
    });
  }
}

export { mount };
